import React, { PropTypes } from 'react';

import Question from './Question';
import Page from '../../Page';


class Quiz extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionIndex: 0
    };
    this.onNextQuestion = this.onNextQuestion.bind(this);
  }

  onNextQuestion() {
    this.setState((currentState) => {
      return {
        questionIndex: currentState.questionIndex + 1
      };
    });
  }



  render() {
    const { value: { questions, countertext, nextbutton, finishbutton, finishcontent,    ...rest } } = this.props;
    const { questionIndex } = this.state;
    const styles = require('./Quiz.scss');
    return (
      <div className={styles.wrapper}>
        <a id="q" className={styles.anchor} />
        {questionIndex < questions.length &&
          [
            <div className={styles.counter}>{`${countertext} ${questionIndex + 1} / ${questions.length}`} </div>,
            <Question value={Object.assign(rest, questions[questionIndex].value)}/>
          ]
        }
        {questionIndex < questions.length - 1 &&
          <a className={styles.nextbutton} onClick={this.onNextQuestion} href="#q">{nextbutton}</a>
        }
        {finishbutton && questionIndex === questions.length - 1 &&
          <a className={styles.nextbutton} onClick={this.onNextQuestion} href="#q">{finishbutton}</a>
        }
        {finishcontent && questionIndex === questions.length &&
          <Page data={finishcontent} />
        }
      </div>
    );
  }


}

Quiz.propTypes = {
  value: PropTypes.shape({
    questions: PropTypes.array,
    nextbutton: PropTypes.string,
    finishbutton: PropTypes.string,
    finishcontent: PropTypes.array
  })
};



export default Quiz;




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/InfoQuiz/Quiz.js
 **/